import { Component } from '@angular/core';

@Component({
	selector: 'app-silent-refresh',
	standalone: true,
	template: `
		<script>
			// This script handles the silent refresh iframe
			try {
				// Check if parent window exists (we're in an iframe)
				if (window.parent && window.parent !== window) {
					// Get the fragment from the URL (contains the new tokens)
					const fragment = window.location.hash;

					// Post the fragment to the parent window
					if (fragment) {
						window.parent.postMessage(fragment, window.location.origin);
					} else {
						// If no fragment, post the entire URL for debugging
						window.parent.postMessage(window.location.href, window.location.origin);
					}
				}
			} catch (error) {
				// console.error('Error in silent refresh:', error);
			}
		</script>
	`,
})
export class SilentRefreshComponent {
	constructor() {
		console.log('🔄 Silent Refresh: Component initialized');
		// Execute the silent refresh logic immediately
		setTimeout(() => this.handleSilentRefresh(), 0);
	}

	private handleSilentRefresh(): void {
		console.log('🔄 Silent Refresh: Starting token refresh process');
		console.log('🔄 Silent Refresh: Current URL:', window.location.href);
		console.log('🔄 Silent Refresh: URL Fragment:', window.location.hash);

		try {
			// Check if parent window exists (we're in an iframe)
			if (window.parent && window.parent !== window) {
				console.log('🔄 Silent Refresh: Parent window detected, processing in iframe');

				// Get the fragment from the URL (contains the new tokens)
				const fragment = window.location.hash;

				// Post the fragment to the parent window
				if (fragment) {
					console.log('🔄 Silent Refresh: Fragment found, posting to parent:', fragment.substring(0, 50) + '...');
					window.parent.postMessage(fragment, window.location.origin);
				} else {
					console.log('🔄 Silent Refresh: No fragment found, posting full URL for debugging');
					// If no fragment, post the entire URL for debugging
					window.parent.postMessage(window.location.href, window.location.origin);
				}
			} else {
				console.log('🔄 Silent Refresh: No parent window detected - not in iframe');
			}
		} catch (error) {
			console.error('🔄 Silent Refresh: Error occurred:', error);
		}
	}
}
